/**
 * Enumeração que lista as possíveis origens de uma mensagem.
 * Basicamente, a mensagem pode vir apenas do Bot ou do Usuário.
 */
 export enum Origin {
    USER = "incoming",
    BOT = "outcoming"
}